import HardwareSerializer from 'eflex/serializers/hardware';

export default class PlcHardwareSerializer extends HardwareSerializer {}
